const profileIT = {
    "edit": {
        "title": "Modifica il tuo profilo",
        "form": {
            "label": {
                "profileImage": "Immagine del profilo",
                "streetAndNumber": "La mia via e numero civico",
                "postalCode": "Codice postale",
                "city": "Città",
                "country": "Paese",
                "vatNumber": "Partita IVA",
                "nationalTaxNumber": "Numero fiscale nazionale",
                "businessRegistrationNumber": "Numero di registrazione aziendale",
                "vatStatus": "Stato IVA",
                "businessType": "Tipo di attività",
                "vatExemptDocument": "Documento di esenzione IVA",
                "businessCertificate": "Certificato aziendale",
                "preferredPaymentMethod": "Metodo di pagamento preferito",
                "paypalEmail": "Email Paypal",
                "accountHolderName": "Nome del titolare del conto bancario",
                "bankName": "Nome della banca",
                "bankAddress": "Indirizzo della banca",
                "iban": "IBAN"
            },
            "option": {
                "preferedMethod": {
                    "paypal": "Paypal",
                    "bankAccount": "Conto bancario"
                }
            },
            "help_text": {
                "profileImage": "Carica formati JPG, risoluzione solo 300x300 px, dimensione massima 300 KB.",
                "iban": "Ricorda il prefisso del tuo paese, ad esempio DE, FR, ES"
            },
            "button": {
                "submit": "Invia"
            }
        },
        "message": {
            "success": "Il tuo profilo è stato aggiornato!",
            "error": "Qualcosa è andato storto! Per favore aggiorna la pagina e riprova!"
        },
        "modal": {
            "header": "Sei sicuro di voler cambiare il tuo profilo?",
            "body": "Con la presente garantisci che tutti i dati forniti sono veritieri. Sei l'unico e legalmente responsabile per i dati forniti e per la veridicità di tali informazioni.",
            "button": {
                "cancel": "Annulla",
                "confirm": "Conferma"
            }
        }
    },
    "set_new_password": {
        "title": "Imposta nuova password",
        "form": {
            "label": {
                "currentPassword": "Password attuale",
                "newPassword": "Nuova password",
                "repeatNewPassword": "Ripeti nuova password"
            },
            "button": {
                "submit": "Invia"
            },
            "validation": {
                "oldPasswordRequired": "La tua vecchia password è richiesta",
                "newPasswordMin": "La tua password deve essere lunga almeno 10 caratteri",
                "newPasswordRequired": "È richiesta una nuova password",
                "passwordsMustMatch": "La nuova password deve corrispondere"
            }
        },
        "message": {
            "success": "La tua password è stata cambiata!",
            "error": "Qualcosa è andato storto! Per favore aggiorna la pagina e riprova!"
        },
        "modal": {
            "header": "Sei sicuro di voler cambiare la tua password?",
            "body": "Per favore conferma"
        }
    },
    "panel": {
        "label": {
            "emailAddress": "Indirizzo email",
            "paypalEmailAddress": "Indirizzo email Paypal",
            "phone": "Telefono",
            "streetAndHouseNumber": "Via e numero civico",
            "postalCode": "Codice postale",
            "city": "Città",
            "country": "Paese",
            "paymentMethod": "Metodo di pagamento",
            "accountNumberHolder": "Titolare del conto",
            "bankName": "Nome della banca",
            "iban": "IBAN",
            "bic": "BIC",
            "bankAddress": "Indirizzo della banca",
            "paypal": "Paypal",
            "bankAccount": "Conto bancario"
        }
    },
    "payment_method": {
        "title": "Metodo di pagamento",
        "label": {
            "card_number": "Numero di carta",
            "card_expiry": "Scadenza",
            "default_method": "Predefinito",
            "manage_method": "Gestisci",
            "add_method": "Aggiungi"
        }
    },
    "withholding_tax": {
        "title": "Ritenuta d'acconto",
        "form": {
            "label": {
                "taxPercentage": "Percentuale di imposta",
                "whtStatus": "Stato WHT",
                "whtLicense": "Licenza WHT"
            },
            "help_text": {
                "uploadDocument": "Per favore carica il tuo documento di ritenuta d'acconto."
            },
            "button": {
                "submit": "Invia",
                "removeFile": "Rimuovere?"
            },
            "message": {
                "whtStatusText": "Secondo l'Articolo 31 della Legge sull'imposta sui profitti croata, una ritenuta d'acconto del 15-25% si applica ai non residenti. Tuttavia, se risiedi in un paese che ha un Accordo per evitare la doppia imposizione con la Croazia, potresti qualificarti per un'aliquota fiscale ridotta. Puoi verificare se il tuo paese è elencato su <1><strong>questo link</strong></1>.",
                "whtApplyRateText": "Per richiedere l'aliquota ridotta, per favore clicca su <1><strong>questo documento</strong></1>. Scarica, completa e invia il modulo per beneficiare dell'aliquota specificata nell'accordo se idoneo."
            }
        },
        "message": {
            "success": "Licenza WHT inviata con successo. Sarà elaborata dal nostro team.",
            "error": "Si è verificato un errore durante l'aggiornamento. Per favore riprova."
        }
    }
};

export default profileIT;